import React from "react";
import ReactDOM from "react-dom";
import { Provider } from "react-redux";
import App from "./App";
import * as serviceWorker from "./serviceWorker";
import configureAppStore from "./store";
import "./styles/app.css";
import "./styles/bootstrap.css";

// import whyDidYouUpdate from "@welldone-software/why-did-you-render";
// whyDidYouUpdate(React, {include: [/^IncomeItem/], trackHooks: true});

const store = configureAppStore();
export default store;

const Root = () => (
  <Provider store={store}>
    <App />
  </Provider>
);

ReactDOM.render(<Root />, document.getElementById("root"));

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
